const ro = {
    home: 'Home',
    services: 'Servicii',
    appointments: 'Programări',
    bookings: 'Rezervări',
    statistics: 'Statistici',
    users: 'Utilizatori',
    login: 'Autentificare',
    register: 'Înregistrare',
    profile: 'Profil',
    logout: 'Deconectare',
    language: 'Limba',
    packages: 'Pachete',
    select_service: 'Selectați un serviciu:',
    choose_service: 'Alegeți un serviciu',
    capacity: 'Capacitate:',
    people: 'persoane',
    select_interval: 'Selectați intervalul de timp:',
    minutes_15: '15 minute',
    minutes_20: '20 minute',
    minutes_30: '30 minute',
    minutes_60: '1 oră',
    select_service_alert: 'Vă rugăm să selectați un serviciu din listă!',
    login_error: 'Eroare de autentificare, încercați din nou!',
    move_failed: 'Mutarea nu a reușit.',
    booking_failed: 'Rezervarea nu a reușit.',
    delete_booking_failed: 'Ștergerea rezervării a eșuat.',
    confirm_delete: 'Sigur doriți să ștergeți evenimentul?',
    today: 'Azi',
    month: 'Lună',
    week: 'Săptămână',
    day: 'Zi',
    yes: 'Da',
    no: 'Nu',
    service: 'Serviciu',
    start_time: 'Începutul programării:',
    end_time: 'Sfârșitul programării:',
    name: 'Nume',
    actions: 'Acțiuni',
    accept: 'Acceptă',
    reject: 'Respinge',
    delete: 'Șterge',
    move: 'Mută',
    cancel: 'Anulează',
    confirm_appointment_delete: 'Sigur doriți să ștergeți această programare?',
    book_by_name: 'Rezervare pe nume',
    enter_name: 'Introduceți numele pentru rezervare:',
    book: 'Rezervă',
    appointment_delete: 'Șterge programarea',
    move_appointment: 'Mutare programare',
    delete_appointment: 'Ștergere programare',
    package_title: 'Pachete de Servicii',
    price: 'Preț',
    duration: 'Durată',
    hours: 'ore',
    minutes: 'minute',
    edit: 'Editează',
    no_packages: 'Nu există pachete disponibile pentru acest serviciu.',
    add_new_package: 'Adaugă un nou pachet',
    add_package_desc: 'Puteți adăuga un pachet nou pentru acest serviciu.',
    edit_package: 'Editare Pachet',
    new_package: 'Adăugare Pachet Nou',
    description: 'Descriere',
    duration_hours: 'Durată (Ore)',
    duration_minutes: 'Durată (Minute)',
    add: 'Adaugă',
    save: 'Salvează',
    profile_data: 'Datele profilului',
    upload_picture: 'Încărcați o poză',
    username: 'Nume utilizator',
    first_name: 'Prenume',
    last_name: 'Nume de familie',
    email: 'Email',
    phone_number: 'Număr de telefon',
    update_data: 'Actualizați datele',
    profile_update_error: 'A apărut o eroare la actualizarea datelor',
    profile_update_success: 'Datele au fost actualizate cu succes',
    profile_picture_upload_error: 'Eroare la încărcarea pozei de profil',
    existing_services: 'Servicii Existente',
    service_name: 'Numele Serviciului',
    choose_category: 'Alegeți o categorie',
    category: 'Categorie',
    available: 'Disponibil',
    sms_notification: 'Notificare SMS',
    email_notification: 'Notificare Email',
    update_service: 'Actualizează Serviciul',
    create_service: 'Crează Serviciu Nou',
    image_upload_error: 'Eroare la încărcarea imaginii',
    general_error: 'Eroare: ',
    delete_service_error: 'Eroare la ștergerea serviciului: ',
    create_success: 'Serviciu creat cu succes',
    update_success: 'Serviciu actualizat cu succes',
    category_label: 'Categorie',
    available_label: 'Disponibil',
    provider: 'Furnizor',
    forgot_password_title: 'Parolă uitată',
    forgot_password: 'Parolă uitată',
    reset_password: 'Resetare parolă',
    reset_email_sent: 'Verifică-ți e-mailul pentru linkul de resetare a parolei.',
    error_try_again: 'A apărut o eroare. Vă rugăm să încercați din nou.',
    network_error: 'Eroare de rețea. Vă rugăm să încercați mai târziu.',
    confirm_password: 'Confirmare parolă',
    consent_prefix: '„Îmi dau consimțământul pentru prelucrarea datelor personale conform ',
    privacy_policy: 'Politicii de Confidențialitate',
    consent_suffix: '. Sunt conștient că îmi pot retrage consimțământul oricând.”',
    must_accept_privacy: 'Trebuie să acceptați politica de confidențialitate pentru a continua înregistrarea.',
    passwords_do_not_match: 'Parolele nu se potrivesc!',
    registration_success: 'Activează din linkul din e-mail. Verifică și Spam.',
    privacy_modal_title: 'Politica de Confidențialitate',
    privacy_modal_1_title: '1. Numele și contactul operatorului de date',
    privacy_modal_1_content: 'Numele și adresa companiei care administrează datele și informațiile de contact.',
    privacy_modal_2_title: '2. Datele colectate',
    privacy_modal_2_content: 'Colectăm următoarele date personale: nume, adresă de email, număr de telefon, adresă IP și alte date legate de utilizarea serviciului nostru.',
    privacy_modal_3_title: '3. Scopul și temeiul legal al prelucrării datelor',
    privacy_modal_3_content: 'Scopul colectării datelor este asigurarea înregistrării, menținerea contactului și furnizarea serviciilor. Temeiul legal al prelucrării este consimțământul voluntar, care poate fi retras oricând.',
    privacy_modal_4_title: '4. Perioada de stocare a datelor',
    privacy_modal_4_content: 'Datele vor fi stocate doar pe perioada necesară sau conform cerințelor legale.',
    privacy_modal_5_title: '5. Măsuri de securitate a datelor',
    privacy_modal_5_content: 'Implementăm măsuri tehnice și organizaționale pentru a asigura protecția și confidențialitatea datelor.',
    privacy_modal_6_title: '6. Transferul datelor și procesatorii de date',
    privacy_modal_6_content: 'Transferul datelor către terți se face doar cu consimțământul explicit al utilizatorului sau conform obligațiilor legale.',
    privacy_modal_7_title: '7. Drepturile utilizatorilor',
    privacy_modal_7_list1: 'Dreptul de acces: utilizatorii pot solicita accesul la datele lor stocate.',
    privacy_modal_7_list2: 'Dreptul de rectificare: pot solicita corectarea oricăror inexactități.',
    privacy_modal_7_list3: 'Dreptul de ștergere: pot solicita ștergerea datelor personale, dacă acestea nu mai sunt necesare.',
    privacy_modal_8_title: '8. Contact',
    privacy_modal_8_content: 'Pentru orice întrebări legate de prelucrarea datelor personale, ne puteți contacta la adresa de e-mail: [email protected]',
    new_password: 'Parolă nouă',
    password_reset_success: 'Parola ta a fost resetată cu succes.',
    error_occurred: 'A apărut o eroare.',
    loading_data: 'Se încarcă datele...',
    close: 'Închide',
    details: 'Detalii',
    password: 'Parola',
    view: 'Vizualizează',
    select_package: 'Selectați un pachet',
    choose: 'Selectează',
    no_packages_for_appointment: 'Nu există pachete disponibile pentru această programare.',
    no_packages_for_service: 'Nu există pachete pentru acest serviciu.',
    bookings_title: 'Programări',
    no_bookings: 'Nu există programări',
    used_package: 'Pachet utilizat',
    package_name: 'Numele pachetului',
    package_description: 'Descriere',
    package_price: 'Preț',
    package_duration: 'Durată',
    duration_0: '0 ore 0 minute',
    no_package_attached: 'Niciun pachet asociat.',
    open_in_calendar: 'Deschide în calendar',
    confirmed: 'Confirmat',
    pending: 'În așteptare',
    rejected: 'Respins',
    all_categories: 'Toate categoriile',
    status_confirmed: 'Acceptat',
    status_pending: 'În așteptare',
    status_rejected: 'Respins',
    statistics_loading_error: 'A apărut o eroare la încărcarea statisticilor',
    total_bookings: 'Total rezervări',
    most_booked_service: 'Cel mai rezervat serviciu',
    total_services: 'Total servicii',
    bookings_by_service: 'Rezervări grupate după serviciu',
    bookings_by_package: 'Rezervări grupate după pachet',
    booking_count: 'Număr de rezervări',
    loading: 'Se încarcă...',
    confirm_booking: "Sigur doriți să faceți o rezervare pentru acest interval?",
    confirm_cancel_booking: "Sigur doriți să anulați această rezervare?",
    failed_cancel_booking: "Anularea rezervării a eșuat.",
    error_delete_booking: 'Eroare la ștergerea programării:',
    client_list: 'Lista de clienți',
    clients: 'Clienți',
    client_name: 'Nume',
    client_email: 'Email',
    client_phone: 'Telefon',
    status: 'Statut',
    client_blocked_successfully: 'Clientul a fost blocat cu succes',
    block: 'Blochează',
    client_blocked_successfully: 'Clientul a fost blocat cu succes.',
    client_unblocked_successfully: 'Clientul a fost deblocat cu succes.',
    block: 'Blochează',
    unblock: 'Deblochează',
    service_not_visible: "Sunteți blocat la acest furnizor.",
    delete_booking: 'Șterge programarea',
    confirm_cancel_booking: "Sigur doriți să anulați rezervarea?",
    booking_cancelled_success: "Rezervarea a fost anulată cu succes.",
    booking_cancelled_error: "Anularea rezervării a eșuat.",
    not_booked_by_you: "Această rezervare nu este a dumneavoastră.",
    booking_success: 'Pachet rezervat cu succes.',
    booking_failed: 'Rezervarea pachetului a eșuat.',
    booking_error: 'A apărut o eroare în timpul rezervării.',
    confirm_delete_package: "Sigur doriți să ștergeți acest pachet?",
    package_deleted_success: "Pachetul a fost șters cu succes.",
    package_deleted_error: "Ștergerea pachetului a eșuat.",
    user_type: "Tip utilizator",
    client: "Client (rezervă programări)",
    provider: "Firmă (oferă servicii)",
    nav_title: "Navigație",
    nav_home: "Acasă",
    nav_services: "Servicii",
    nav_appointments: "Programări",
    nav_bookings: "Rezervări",
    nav_statistics: "Statistici",
    nav_users: "Utilizatori",
    nav_my_bookings: "Rezervările mele",
    nav_profile: "Profil",
  
    
    bookings_at_my_services: 'Rezervări la serviciile mele',
    my_bookings: 'Rezervările mele',

    extra_title: "Extra",
    extra_notifications: "Notificări",
    extra_messages: "Mesaje",
    extra_favorites: "Favorite",
    extra_help: "Ajutor & Întrebări",
    extra_privacy: "Confidențialitate",
    extra_settings: "Setări",
  
    system_title: "Sistem",
    system_language: "Limbă",
  
    auth_logout: "Deconectare",
    auth_login: "Autentificare",
    footer_copy: "© {year} MyServiceHub",
    nav_home_l1: "Acasă",
    nav_home_l2: "",
  
    nav_services_l1: "Servicii",
    nav_services_l2: "",
  
    nav_appointments_l1: "Progra",
    nav_appointments_l2: "mări",
  
    nav_bookings_l1: "Rezer",
    nav_bookings_l2: "vări",
  
    nav_statistics_l1: "Statis",
    nav_statistics_l2: "tici",
  
    nav_users_l1: "Utiliza",
    nav_users_l2: "tori",

    subnav_appointments_l1: "Progra",
    subnav_appointments_l2: "mări",
    
    subnav_services_l1: "Servicii",
    subnav_services_l2: "",
    
    subnav_packages_l1: "Pachete",
    subnav_packages_l2: "",
    
    subnav_clients_l1: "Clienți",
    subnav_clients_l2: "",
    home_badge: 'Servicii • Programări • Simplu',
    home_hero_title: 'Programează-te în câteva secunde',
    home_hero_subtitle: 'Găsește prestatorul potrivit și rezervă online – rapid, clar și fără stres.',
    home_cta_browse: 'Caută servicii',
    home_cta_register: 'Înregistrează-te ca prestator',
    features_title: 'De ce MyServiceHub?',
    feature_1_title: 'Programare transparentă',
    feature_1_desc: 'Disponibilitate în timp real, prețuri și durate clare.',
    feature_2_title: 'Notificări',
    feature_2_desc: 'Email/SMS reminder ca să nu ratezi nimic.',
    feature_3_title: 'Statistici pentru profesioniști',
    feature_3_desc: 'Servicii populare și perioade aglomerate – totul într-un loc.',
    feature_4_title: 'Start ultra-rapid',
    feature_4_desc: 'Câteva clicuri și poți primi rezervări.',
    how_title: 'Cum funcționează?',
    how_1_title: 'Căutare',
    how_1_desc: 'Alege o categorie și răsfoiește prestatorii.',
    how_2_title: 'Rezervare',
    how_2_desc: 'Alege ora potrivită și rezervă imediat.',
    how_3_title: 'Notificare',
    how_3_desc: 'Trimitem un reminder ca să ajungi la timp.',
    testimonials_title: 'Testimoniale',
    testimonial_1_quote: 'În sfârșit o platformă care chiar simplifică rezervările!',
    testimonial_1_name: 'Nora, cosmeticiană',
    testimonial_2_quote: 'Am vizibil mai mulți clienți de când sunt aici.',
    testimonial_2_name: 'Mark, antrenor',
    cta_banner_title: 'Începe acum!',
    cta_banner_subtitle: 'Creează un profil sau răsfoiește serviciile.',
    cta_banner_btn_browse: 'Servicii',
    cta_banner_btn_register: 'Înregistrare',
    address: 'Adresă',
    enter_address: 'Introduceți adresa',
    // Concedii
    subnav_vacations_l1: "Concedii",
    subnav_vacations_l2: "",
    vacations: "Concedii",

    // Tabel / formular
    from: "De la",
    to: "Până la",
    note: "Notă",
    action: "Acțiune",
    no_data: "Fără date",

    // Hartă
    view_on_map: "Deschide pe hartă",
    on_vacation: 'Concediu',
    all_day: 'Toată ziua',
    notifications_title: "Notificări",
    notifications_loading: "Se încarcă…",
    notifications_empty: "Nu există notificări de afișat.",
    notifications_filter: "Filtru",
    notifications_filter_all: "Toate",
    notifications_filter_unread: "Necitite",
    notifications_filter_read: "Citite",
    notifications_search_ph: "Caută în titlu sau mesaj…",
    notifications_refresh: "Reîmprospătare",
    notifications_mark_all: "Marchează toate ca citite",
    notifications_mark_read: "Marchează citit",
    notifications_mark_unread: "Marchează necitit",
    notifications_delete: "Șterge",
    notifications_open_related: "Deschide pagina asociată",
    notifications_item_no_title: "Fără titlu",
    notifications_unread_chip: "{n} necitite",
    notifications_unread_dot: "Indicator necitit",
    notifications_fallback: "Serverul nu este disponibil – date demo sunt afișate.",
    badge_unread: "Numărul notificărilor necitite",
    extra_notifications: "Notificări",
    delete_account: 'Șterge contul',
    confirm_delete_account: 'Sigur vrei să-ți ștergi contul? Această acțiune nu poate fi anulată.',
    account_deleted_success: 'Contul a fost șters cu succes.',
    account_deleted_error: 'A apărut o eroare la ștergerea contului.',
    or: "sau",
    google_login_failed: "Conectarea cu Google a eșuat. Încearcă din nou.",
    must_accept_privacy: "Trebuie să accepți politica de confidențialitate pentru a continua.",
    registration_success_email_sent: 'Vă rugăm să vă activați contul din e-mailul primit. Verificați și folderul Spam.',
    registration_success_auto_activated: 'Înregistrare reușită! Contul a fost activat imediat pe baza verificării Google.',
    please_choose: '— Vă rugăm să alegeți —',
    phone_required: 'Vă rugăm să introduceți un număr de telefon valid.',
    user_type_required: 'Vă rugăm să selectați tipul de utilizator.',
    continue_with_google: 'Continuați cu Google.',
    choose_country: 'Toate țările',
    country: 'Țara',
    city: 'Oraș',
    select_city: 'Toate orașele',
    client_packages: 'Pachetele clientului',
    select_client: 'Selectează clientul',
    no_packages_for_appointment: 'Nu există pachete pentru această programare.',
    loading_data: 'Se încarcă...',
    free: 'Liber',
    no_user_for_selected_booking: 'Această rezervare nu are utilizator (a fost creată după nume), deci nu se pot încărca pachetele.',
    missing_user_id: 'Lipsește parametrul user_id.',
    invalid_user_id: 'ID utilizator invalid.',
    choose_country_first: "Selectați mai întâi o țară",
  };
  
  export default ro;
  